export default __webpack_public_path__ + "static/media/cryptoSeminar.de8a4e5d.png";